import { useEffect, useRef, useState } from "react";
import { SORT_OPTIONS, type SortKey } from "@/lib/videoQuery";

interface SortDropdownProps {
  value: SortKey;
  onChange: (value: SortKey) => void;
}

export default function SortDropdown({ value, onChange }: SortDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const current = SORT_OPTIONS.find((option) => option.key === value) ?? SORT_OPTIONS[0];

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
      >
        <i className="ri-sort-desc" />
        {current.label}
        <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-2 w-36 overflow-hidden rounded-md border border-background-200 bg-background-50 py-1">
          {SORT_OPTIONS.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => {
                onChange(option.key);
                setOpen(false);
              }}
              className={
                option.key === value
                  ? "block w-full px-4 py-2 text-left text-sm font-medium text-primary-600"
                  : "block w-full px-4 py-2 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100"
              }
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}